import { useEffect, useRef, useState } from "react";

export default function PdfConsentModal({
  isOpen,
  pdfUrl,
  agreeConsent = () => {},
}) {
  const scrollRef = useRef(null);
  const [canAccept, setCanAccept] = useState(false);

  // Track scroll to bottom
  useEffect(() => {
    if (!isOpen) return;

    setCanAccept(false); // reset when modal opens

    const el = scrollRef.current;
    if (!el) return;

    const onScroll = () => {
      // 5px tolerance
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 5) {
        setCanAccept(true);
      }
    };

    el.addEventListener("scroll", onScroll);
    return () => el.removeEventListener("scroll", onScroll);
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div style={overlay}>
      <div style={modal}>
        <div ref={scrollRef} style={scrollArea}>
          <iframe
            src={`${pdfUrl}#toolbar=0&navpanes=0`}
            style={{ width: "100%", height: "100%", border: "none" }}
            title="T&C"
          />

          <div style={footer}>
            <button
              disabled={!canAccept}
              onClick={agreeConsent}
              className="btn btn-primary"
              style={{
                ...button,
                opacity: canAccept ? 1 : 0.5,
                cursor: canAccept ? "pointer" : "not-allowed",
              }}
            >
              Accept
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ---------------- STYLES ---------------- */

const overlay = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.6)",
  zIndex: 9999,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const modal = {
  width: "80%",
  height: "90%",
  background: "#fff",
  borderRadius: 8,
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
};

const scrollArea = {
  flex: 1,
  overflowY: "auto",
};

const footer = {
  textAlign: "center",
  padding: "24px",
};

const button = {
  padding: "12px 28px",
  fontSize: 16,
};
